import React, { FC, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { FilterBar } from 'components/molecules/filter-bar';
import { Page } from 'components/molecules/page';

interface Props {
  title: ReactNode;
  documentTitle: string;
}

const Content = styled(Page.Content)`
  padding: var(--layout-03);
  padding-left: calc(var(--layout-03) + var(--spacing-03));
  ${FilterBar} {
    padding: 0;
    margin-bottom: var(--layout-02);
    box-shadow: none;
  }
`;

export const Helium: FC<Props> = ({ title, documentTitle, children }) => {
  return (
    <Page>
      <Page.Header
        $white
        sticky
        title={<Page.Header.Title>{title}</Page.Header.Title>}
      />

      <Helmet>
        <title>{documentTitle}</title>
      </Helmet>
      <Content>{children}</Content>
    </Page>
  );
};
